var map = {
	"./ar.json": [
		5638,
		5638
	],
	"./cn.json": [
		9231,
		9231
	],
	"./de.json": [
		9810,
		9810
	],
	"./es.json": [
		4392,
		4392
	],
	"./fr.json": [
		8236,
		8236
	],
	"./hu.json": [
		2262,
		2262
	],
	"./id.json": [
		3440,
		3440
	],
	"./ir.json": [
		4905,
		4905
	],
	"./it.json": [
		4152,
		4152
	],
	"./jp.json": [
		1274,
		1274
	],
	"./ko.json": [
		778,
		778
	],
	"./pl.json": [
		5752,
		5752
	],
	"./pt.json": [
		5287,
		5287
	],
	"./ru.json": [
		5865,
		5865
	],
	"./tr.json": [
		5509,
		5509
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7917;
module.exports = webpackAsyncContext;